import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import AreaID from "../../../components/ecoUser/areaID/AreaID";
import Limits from "../../../components/ecoUser/limits/Limits";
import ReactGA from "react-ga4";
import LimitDetails from "../../../components/ecoUser/limitDetails/LimitDetails";

export default function Ecology() {
  const [currentArea, setCurrentArea] = useState("");
  const [currentLimit, setCurrentLimit] = useState({});
  const [areasData, setAreasData] = useState({});
  const [networksData, setNetworksData] = useState({});

  const { areas, isEcologyPending, isEcologySuccess, areasList, networks } =
    useOutletContext();

  useEffect(() => {
    if (!isEcologyPending) {
      setAreasData(areas);
      setNetworksData(networks);
      setCurrentArea(Object.keys(areas)[0]);
      setCurrentLimit(areas[Object.keys(areas)[0]]?.configs?.[0]);
    }
  }, [areas, networks, isEcologyPending]);

  useEffect(() => {
    if (!currentArea) return;

    const firstLimit = areas[currentArea]?.configs?.[0] ?? null;
    setCurrentLimit(firstLimit);
  }, [currentArea, areas]);

  useEffect(() => {
    ReactGA.event("screen_view", {
      firebase_screen: "EcologyPage",
    });
  }, []);

  return (
    <div className="eco">
      <AreaID
        areasList={areasList}
        isPending={isEcologyPending}
        setCurrentArea={setCurrentArea}
      />
      <Limits
        areasData={areasData}
        networksData={networksData}
        setAreasData={setAreasData}
        isPending={isEcologyPending}
        currentArea={currentArea}
        areasList={areasList}
        currentLimit={currentLimit}
        setCurrentLimit={setCurrentLimit}
      />
      {/* <LimitDetails
        currentArea={currentArea}
        currentLimit={currentLimit}
        isEcologySuccess={isEcologySuccess}
      /> */}
    </div>
  );
}
